// The DMARCeye MCP server connect facts consumed by the AI chat page context
// (useAiPageContext), so the assistant can walk a user through connecting with
// the same i18n texts the installation page shows. The model cannot browse URLs,
// so the concrete steps must travel in the payload text itself — not a docs link.
//
// SYNC WARNING: Pages/Integrations/McpServer/index.vue currently keeps its OWN
// hardcoded step-key structures (richer shape, incl. the step-4 assistant notes,
// deliberately omitted here) and does not import this module yet. When install
// steps change on that page, mirror the flat key lists here — until the page is
// refactored to render from this module.

export const MCP_CONNECT_URL = "https://app.dmarceye.com/mcp";

// Ordered i18n keys for the concrete ChatGPT connect steps.
export const MCP_CHATGPT_STEP_KEYS: string[] = [
    "vue.mcp_install_step1_item1",
    "vue.mcp_install_step1_item2",
    "vue.mcp_install_step1_item3",
    "vue.mcp_install_step2_item1",
    "vue.mcp_install_step2_item2",
    "vue.mcp_install_step2_item2_name",
    "vue.mcp_install_step2_item2_url",
    "vue.mcp_install_step2_item3",
    "vue.mcp_install_step2_item4",
    "vue.mcp_install_step3_item1",
    "vue.mcp_install_step3_item2",
    "vue.mcp_install_step3_item3",
    "vue.mcp_install_step3_item4",
    "vue.mcp_install_step3_item5",
    "vue.mcp_install_step4_item1",
    "vue.mcp_install_step4_item2",
    "vue.mcp_install_step4_item3",
];

// Ordered i18n keys for the concrete Claude connect steps.
export const MCP_CLAUDE_STEP_KEYS: string[] = [
    "vue.mcp_install_claude_step1_item1",
    "vue.mcp_install_claude_step1_item2",
    "vue.mcp_install_claude_step2_item1",
    "vue.mcp_install_claude_step2_item2",
    "vue.mcp_install_claude_step2_item2_name",
    "vue.mcp_install_claude_step2_item2_url",
    "vue.mcp_install_claude_step2_item3",
    "vue.mcp_install_claude_step3_item1",
    "vue.mcp_install_claude_step3_item2",
    "vue.mcp_install_claude_step3_item3",
    "vue.mcp_install_claude_step3_item4",
    "vue.mcp_install_claude_step3_item5",
    "vue.mcp_install_claude_step4_item1",
    "vue.mcp_install_claude_step4_item2",
    "vue.mcp_install_claude_step4_item3",
];

// i18n keys for the per-client plan requirements.
export const MCP_REQUIREMENT_KEYS: { chatgpt: string; claude: string } = {
    chatgpt: "vue.mcp_install_requires_chatgpt",
    claude: "vue.mcp_install_requires_claude",
};
